module.exports = __webpack_public_path__ + "static/media/1011095.b2a4095b.jpg";